<template>
  <div class="elementsLine">
    <hr>
  </div>
</template>

<script>

export default {
  name: 'ElementsLine',
}
</script>
